import { buildRoleByIdMap, formatRoleLevelFromRoleId } from './format_role_level_display.function';

export const enrichRoleAssignments = (assignments, usersList, rolesList = []) => {
  const roleById = buildRoleByIdMap(rolesList);

  return assignments.map((assignment) => {
    const user = usersList.find((u) => u.id === assignment.user_id);
    return {
      ...assignment,
      user_name: user?.name || 'N/A',
      email: user?.email || 'N/A',
      region: user?.region || 'N/A',
      role_name: formatRoleLevelFromRoleId(assignment.role_name, assignment.role_id, roleById),
    };
  });
};
